import { Col, Container, Row } from "react-bootstrap";
import { useEffect } from "react";
import { SiNodedotjs, SiReact, SiGo, SiMysql, SiTensorflow, SiMongodb, SiTypescript, SiDocker } from 'react-icons/si';

const skills = [
    { icon: SiNodedotjs,   title: "Node.js",                 color: "#339933" },
    { icon: SiReact,       title: "React",                   color: "#61DAFB" },
    { icon: SiGo,          title: "Golang",                  color: "#00ADD8" },
    { icon: SiTypescript,  title: "TypeScript",              color: "#3178C6" },
    { icon: SiTensorflow,  title: "A.I.",                    color: "#FF6F00" },
    { icon: SiMongodb,     title: "NoSQL",                   color: "#47A248" },
    { icon: SiMysql,       title: "MySQL",                   color: "#4479A1" },
    { icon: SiDocker,      title: "Docker",                  color: "#2496ED" },
];

export const Skills = () => {

    useEffect(() => {
        const revealSkills = () => {
            var revealElement = document.querySelectorAll(".reveal")
            for (var i = 0; i < revealElement.length; i++) {
                var windowHeight = window.innerHeight;
                var revealTop = revealElement[i].getBoundingClientRect().top;
                var revealPoint = 150;
                if (revealTop < windowHeight - revealPoint) {
                    revealElement[i].classList.add("active")
                }
            }
        }
        revealSkills()
        window.addEventListener("scroll", revealSkills);
        return () => window.removeEventListener("scroll", revealSkills);
    });

    return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skills-box">
                        <h2>Skills</h2>
                        <p>These are my skills, I always look forward to improve every one of them, to achieve web transcendence.</p>
                        <Container className="reveal">
                            <Row className="justify-content-center">
                                {skills.map((skill, index) => (
                                    <Col key={index} xs={6} sm={4} md={3} className="skill-icon-col">
                                        <div className="skill-icon-card">
                                            <skill.icon size={52} color={skill.color} />
                                            <p>{skill.title}</p>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
